export function average(ctx) {
    const values = ctx.chart.data.datasets[0]?.data;
    if (!values)
      return 0;
    return values.reduce((a, b) => {
      return a + b.y;
    }
      , 0) / values.length;
  }